import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/design/tokens.css';
import { App } from '@/app/App';

const container = document.getElementById('root');
if (!container) throw new Error('חסר אלמנט root ב index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
